import { css } from "@emotion/react";

export const styleOverride = css`
display: block;
margin: 30px auto;
border-color: red;
`;
